import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isTokenExpired } from "helpers/api_helper";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const token = sessionStorage.getItem("authToken");

  if (!token || isTokenExpired()) {
    return <Navigate to="/login" />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
